export default __webpack_public_path__ + "static/media/about.a7b8cd50.svg";